import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand power distribution, LV switchboards, MV switchgear, protection, testing and electrical safety. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-navy-950 font-sans text-steel-light antialiased" data-id="element-0" data-mp="nur8q7by6l0i">
      <MetaPixel data-id="element-1" data-mp="st2i6gybyti7" />
      <main data-id="element-2" data-mp="swqbpg3rzfwx">
        <Hero data-id="element-3" data-mp="36hwf6uoms18" />
        <LookInsideCarousel data-id="element-4" data-mp="3688dot76uy6" />
        <ProblemSection data-id="element-5" data-mp="35ghgrajple8" />
        <SystemSection data-id="element-6" data-mp="34ncnvv5d5yq" />
        <ModulesSection data-id="element-7" data-mp="3uct4hmy40t22" />
        <BonusSection data-id="element-8" data-mp="3udazyhcy738x" />
        <UrgencySection data-id="element-9" data-mp="3ubzumd3utnfp" />
        <PricingSection data-id="element-10" data-mp="3uevrrz7vo833" />
        <GuaranteeSection data-id="element-11" data-mp="d4o0nv3yoa99" />
        <FAQ data-id="element-12" data-mp="d4xq9hl3gfef" />
        <ClosingSection data-id="element-13" data-mp="d3cvbquvaug1" />
        <SummaryTable data-id="element-14" data-mp="d2l9v8uzid3h" />
        <FinalCta data-id="element-15" data-mp="85l28tihl2a9" />
      </main>
      <Footer data-id="element-16" data-mp="85b8qvy8gczt" />
      <PurchaseNotification data-id="element-17" data-mp="86w4uq0743zs" />
    </div>;
}